window.onload = function () {
  const isAgent = document.getElementById('is_agent_yes') as HTMLInputElement;
  const isNotAgent = document.getElementById('is_agent_no');
  const agentDiv = document.getElementById('authorized_agent');
  const agentName = document.getElementById('agent_name');
  const agentEmailAddress = document.getElementById('agent_email_address');
  const hasWrittenConsent = document.getElementById('has_written_consent');
  const writtenConsent = document.getElementById(
    'written_consent',
  ) as HTMLInputElement;

  const setRequired = () => {
    if (isAgent.checked) {
      agentDiv?.classList.remove('d-none');
      agentName?.setAttribute('required', '');
      agentEmailAddress?.setAttribute('required', '');
      hasWrittenConsent?.setAttribute('required', '');
    } else {
      agentDiv?.classList.add('d-none');
      agentName?.removeAttribute('required');
      agentEmailAddress?.removeAttribute('required');
      hasWrittenConsent?.removeAttribute('required');
    }
  };

  const checkFileSize = () => {
    writtenConsent?.setCustomValidity(
      (writtenConsent?.files?.[0]?.size ?? 0) > 5 * 1024 * 1024
        ? 'Exceeds 5MB size limit'
        : '',
    );
    writtenConsent?.reportValidity();
  };

  isAgent.addEventListener('change', setRequired);
  isNotAgent?.addEventListener('change', setRequired);
  setRequired();

  writtenConsent?.addEventListener('change', checkFileSize);
  checkFileSize();

  const formError = document.querySelector('.invalid-feedback');
  if (formError?.textContent?.trim() !== '') {
    formError?.scrollIntoView({ behavior: 'smooth' });
  }
};
